export function adjustArrows(recommender)
{
    let imageHeight = recommender.querySelector('img').offsetHeight;
    let arrowTop = imageHeight / 2;
    let arrows = recommender.querySelectorAll('.splide__arrow');
    arrows.forEach(function(arrow) {
        arrow.style.top = arrowTop + "px";
    });
    recommender.querySelector('.splide__arrows').classList.remove('d-none');
}